import styled, { css } from 'styled-components'
import Flickity from 'react-flickity-component'
import { StyledCarouselImageWrapper } from './styledCarouselImage'
import { fadeInOutAnimation } from './styledCarouselAnimation'
import { StyledContentSection } from './styledCarouselElements'

export const StyledFlickityImageComponent = styled(Flickity) <{ $height?: number; $visibility?: boolean }>`
  width: 100%;
  outline: 0;
  position: relative;
  overflow-y: unset;

  .flickity-button {
    display: none;
  }

  .flickity-viewport {
    &:focus {
      outline: 0 !important;
    }
  }

  ${props => props.theme.breakpoints.up('md')} {
    width: 68%;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    width: 100%;
  }

  &.flickity-enabled {
    ${StyledCarouselImageWrapper} {
      ${fadeInOutAnimation}
    }
  }

  ${props => !props.$visibility && css`
    display: none;
  `}
`

export const StyledFlickityContentComponent = styled(Flickity) <{ $isContent?: boolean; $visibility?: boolean }>`
  width: 100%;
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  overflow-y: unset;

  &.flickity-enabled {
    ${StyledContentSection} {
      ${fadeInOutAnimation}
    }
  }

  ${props => props.theme.breakpoints.up('sm')} {
    flex-basis: 40%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .flickity-button {
    display: none;
  }

  .flickity-viewport {
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;

    ${props => props.theme.breakpoints.up('sm')} {
      height: ${props => props.theme.typography.pxToRem(460)} !important;
    }

    &:focus {
      outline: 0 !important;
    }

    .flickity-slider {
      height: 100%;

      ${props => props.theme.breakpoints.up('md')} {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
      }
    }
  }

  .flickity-page-dots {
    padding: 0;
    list-style: none;
    text-align: center;
    line-height: 1;

    ${props => props.theme.breakpoints.up('sm')} {
      right: unset;
      bottom: ${props => props.theme.typography.pxToRem(10)};
      margin: 0;
    }

    li {
      margin: 0;

      &::before {
        display: none;
      }
    }

    .dot {
      display: inline-block;
      width: ${props => props.theme.typography.pxToRem(10)};
      height: ${props => props.theme.typography.pxToRem(10)};
      margin: 0 ${props => props.theme.typography.pxToRem(8)};
      background: #333;
      border-radius: 50%;
      opacity: 0.25;
      cursor: pointer;

      &.is-selected {
        opacity: 1;
        color: ${props => props.theme.palette.primary.main};
        background: ${props => props.theme.palette.primary.main};
      }
    }
  }
  ${props => !props.$visibility && css`
  display: none;
  `}
`